'use strict'

var $ = require('jquery');

function Carousel(config) {
	this.config = $.extend({}, {
		component: 'carousel',
		trigger: ['carousel__link'],
		item: 'carousel__image',
		itemWrapper: 'wrapper',
		activeClassModifier: 'active',
		previousClassModifier: 'previous',
		nextClassModifier: 'next',
		startActive: 0,
		firstLastRecipients: [],
		firstLastInViewRecipients: [],
		centerElements: [],
		newHeightScale: 1,
		carouselSpeed: 4000,
		pauseOnScrollTimeout: 500,
		doAutoAdvance: true,
		doPreviousClass: false,
		doReverseAnimation: false,
		doLoop: true,
		doLoopImages: true,
		imageInterval: 4000,
		imageLoopStarted: false,
		callbacks: {}
	}, config);

	this.$carousel = $('.' + this.config.component);

	if (this.$carousel.length == 0) return;

	var that = this;
	// Configure misc. classes classes
	if (this.config.itemActiveClass === undefined) {
		this.config.itemActiveClass = this.config.item + '--' + this.config.activeClassModifier;
	}
	if (this.config.itemWrapperClass === undefined) {
		this.config.itemWrapperClass = this.config.component + '__' + this.config.itemWrapper;
	}
	if (this.config.triggerActiveClass === undefined) {
		this.config.triggerActiveClass = this.config.trigger.map(function (element) {
			return element + '--' + that.config.activeClassModifier;
		});
	}
	if (this.config.doPreviousClass && this.config.itemPreviousClass === undefined) {
		this.config.itemPreviousClass = this.config.item + '--' + this.config.previousClassModifier;
	}
	if (this.config.doPreviousClass && this.config.componentPreviousTriggerClass === undefined) {
		this.config.componentPreviousTriggerClass = this.config.component + '--' + this.config.previousClassModifier;
	}
	if (this.config.componentNextTriggerClass === undefined) {
		this.config.componentNextTriggerClass = this.config.component + '--' + this.config.nextClassModifier;
	}
	if (this.config.doReverseAnimation && this.config.itemActiveRewindClass === undefined) {
		this.config.itemActiveRewindClass = this.config.item + '--' + this.config.activeClassModifier + 'Rewind';
	}
	if (this.config.doReverseAnimation && this.config.itemPreviousRewindClass === undefined) {
		this.config.itemPreviousRewindClass = this.config.item + '--' + this.config.previousClassModifier + 'Rewind';
	}

	this.timeoutId;

	this.$carouselPrevTrigger = $('.' + this.config.componentPreviousTriggerClass);
	this.$carouselNextTrigger = $('.' + this.config.componentNextTriggerClass);
	this.$carouselItem = $('.' + this.config.item);
	this.$carouselItemWrapper = $('.' + this.config.itemWrapperClass);
	this.$activeSlide = $('.' + this.config.itemActiveClass);

	this.info = {
		currentSlide: this.config.startActive,
		slideCount: this.$carouselItem.length
	};
}


/**
 * Match slide to selected trigger
 * @param  {number} triggerIndex The index of the slide to switch to
 */
Carousel.prototype.changeSlide = function (triggerIndex) {
	var that = this;
	this.$activeSlide = this.$carouselItem.eq(triggerIndex);
	var activeTriggers = that.config.trigger.map(function (element, index) {
		return $('.' + element).eq(triggerIndex);
	});
	var oldSlide = this.info.currentSlide;
	var $oldSlide = this.$carouselItem.eq(this.info.currentSlide);
	var isAdvancing = triggerIndex > this.info.currentSlide;

	// Update currentSlide
	this.info.currentSlide = triggerIndex;

	// Remove current active classes
	for (var i = 0; i < this.config.triggerActiveClass.length; i++) {
		$('.' + this.config.triggerActiveClass[i]).removeClass(this.config.triggerActiveClass[i]);
	}
	$('.' + this.config.itemActiveClass).removeClass(this.config.itemActiveClass);

	// Remove current rewind classes
	if (this.config.doReverseAnimation) {
		this.$carouselItem.removeClass(this.config.itemActiveRewindClass);
		this.$activeSlide.removeClass(this.config.itemPreviousRewindClass);

		// Apply rewind classes to new and previous
		if (!isAdvancing) {
			this.$activeSlide.addClass(this.config.itemActiveRewindClass);
			$oldSlide.addClass(this.config.itemPreviousRewindClass);
		}
	}

	// Add active class to triggers
	for (var i = 0; i < activeTriggers.length; i++) {
		activeTriggers[i].addClass(this.config.triggerActiveClass[i]);
	}

	// Center specified active element
	this.centerElement(triggerIndex);

	// Add active class to item
	this.$activeSlide.addClass(this.config.itemActiveClass);
	if (this.config.doPreviousClass) {
		$('.' + this.config.itemPreviousClass).removeClass(this.config.itemPreviousClass);
	}

	// Add active class to wrapper
	if (oldSlide === null) {
		$('.' + this.config.itemWrapperClass).addClass(that.config.itemWrapperClass + '--active');
	}

	// Grow/shrink itemWrapper as appropriate
	if (this.config.doVariableHeight) {
		this.setTimelineHeight(this.$activeSlide);
	}

	// Add first/last class to parent
	if (this.config.firstLastRecipients.length) {
		if (this.info.currentSlide === 0) {
			this.config.firstLastRecipients.forEach(function (element) {
				$('.' + element).addClass('first');
				$('.last', that.$component).removeClass('last');
			});
		} else if (this.info.currentSlide === this.info.slideCount - 1) {
			this.config.firstLastRecipients.forEach(function (element) {
				$('.' + element).addClass('last');
				$('.first', that.$component).removeClass('first');
			});
		} else {
			this.config.firstLastRecipients.forEach(function (element) {
				$('.first', that.$component).removeClass('first');
				$('.last', that.$component).removeClass('last');
			});
		}
	}

	// Run next/previous callbacks
	if (typeof this.config.callbacks.next === 'function' && isAdvancing) {
		this.config.callbacks.next();
	}
	if (typeof this.config.callbacks.previous === 'function' && !isAdvancing) {
		this.config.callbacks.previous();
	}
	if (typeof this.config.callbacks.change === 'function') {
		this.config.callbacks.change()
	}

	// Add/remove .previous class
	if (this.config.doPreviousClass) {
		$oldSlide.addClass(this.config.itemPreviousClass);
	}

	// Restart autoAdvance
	if (this.config.doAutoAdvance) {
		this.startCarousel();
	}
}

// Get index of next and pass to changeSlide()
Carousel.prototype.toNextSlide = function () {
	var isLast = (this.info.currentSlide >= this.info.slideCount - 1);

	// Exit if no loop and is last
	if (!this.config.doLoop && isLast) return;

	// Loop to first if last, else next
	var next = isLast ? 0 : this.info.currentSlide + 1;

	this.changeSlide(next);
}

// Get index of previous and pass to changeSlide()
Carousel.prototype.toPreviousSlide = function () {
	var isFirst = (this.info.currentSlide === 0);

	// Exit if no loop and is first
	if (!this.config.doLoop && isFirst) return;

	// Loop to last if first, else previous
	var previous = isFirst
		? this.info.slideCount - 1
		: this.info.currentSlide - 1;
	this.changeSlide(previous);
}

// Centers an element in a scrollable div
Carousel.prototype.centerElement = function (triggerIndex) {
	var that = this;
	for (var i = 0; i < this.config.centerElements.length; i++) {
		var $element = $('.' + this.config.centerElements[i]);
		var $elementParent = $element.parent();

		var elementParentWidth = $elementParent.width();

		var elementParentCenter = elementParentWidth / 2;

		var selectedElement = $element.get(triggerIndex);
		var left = selectedElement.offsetLeft + (selectedElement.clientWidth / 2) - elementParentCenter;

		$elementParent.animate({ scrollLeft: left }, {
			duration: 350
		});
	}
}

// Stop autoAdvance
Carousel.prototype.stopCarousel = function (timeoutId) {
	var that = this;
	var timeoutId = timeoutId || that.timeoutId;
	window.clearTimeout(timeoutId);
}

// Start autoAdvance
Carousel.prototype.startCarousel = function () {
	var that = this;
	if (that.config.doAutoAdvance) {
		that.timeoutId = window.setTimeout(function () {
			that.toNextSlide();
		}, that.config.carouselSpeed);
	}
}


Carousel.prototype.startImageLoop = function () {
	if (!this.imageLoopStarted){
		(this.$carousel).find('.slide__image:first-child').addClass('image--active');
	}
	window.clearInterval(this.imageIntervalID);
	this.imageIntervalID = window.setInterval(nextImage.bind(this), this.config.imageInterval);
	function nextImage() {
		//console.log((this.$activeSlide).index(), (this.$activeSlide).find('.image--active').index());
		var slideIndex = (this.$activeSlide).index();
		var slide = this.$carouselItem.eq(slideIndex);
		var images = slide.find('.slide__image');

		if (images.length < 2) {
			return;
		} else {
			var active = slide.find('.image--active');
			var indexCurr = active.index();
			var indexNext = (indexCurr < images.length - 1) ? indexCurr + 1 : 0;
			//console.log((this.$activeSlide).index(), (this.$activeSlide).find('.image--active').index());
			images.removeClass('image--active');
			images.eq(indexNext).addClass('image--active');
		}
	}
}

// Pause the carousel while scrolling
Carousel.prototype.autoAdvanceScrollPause = function () {
	if (this.config.doAutoAdvance) {
		var that = this;
		var startBackUpTimeout = undefined;
		$(window).on('scroll', function () {
			if (startBackUpTimeout === undefined) {
				that.stopCarousel(that.timeoutId);
			} else {
				window.clearTimeout(startBackUpTimeout);
			}
			startBackUpTimeout = setTimeout(function () {
				that.startCarousel();
				startBackUpTimeout = undefined;
			}, that.config.pauseOnScrollTimeout);
		})
	}
}


// Initializes default handlers
Carousel.prototype.initHandlers = function () {
	var that = this;

	// Handler: Activate clicked trigger/slide pair
	that.config.trigger.forEach(function (element, index) {
		$('.' + element).on('click', function (event) {
			event.preventDefault();
			for (var i = 0; i < that.config.triggerActiveClass.length; i++) {
				if ($(event.target).hasClass(that.config.triggerActiveClass[index][i])) {
					return;
				}
			}

			var triggerIndex = $(this).index('.' + element);

			if (that.config.doAutoAdvance) {
				that.stopCarousel(that.timeoutId);
			}

			that.changeSlide(triggerIndex);
		});
	});

	// Handler: Change to previous slide on click of previous trigger
	this.$carouselPrevTrigger.on('click', function (event) {
		that.toPreviousSlide();
	});

	// Handler: Change to next slide on click of next trigger
	this.$carouselNextTrigger.on('click', function (event) {
		that.toNextSlide();
	});
}

// Adds position first/last status class to specified elements
Carousel.prototype.initFirstLast = function () {
	if (this.info.currentSlide === 0 && this.config.firstLastRecipients.length) {
		this.config.firstLastRecipients.forEach(function (element) {
			$('.' + element).addClass('first');
		});
	} else if (this.info.currentSlide === this.info.slideCount - 1 && this.config.firstLastRecipients.length) {
		this.config.firstLastRecipients.forEach(function (element) {
			$('.' + element).addClass('last');
		});
	}
}

// Activates the slide and triggers specified to start active
Carousel.prototype.initStartActive = function () {
	if (typeof this.config.startActive !== 'number') return;

	var that = this;
	this.config.trigger.forEach(function (element, index) {
		$('.' + element).eq(that.config.startActive)
			.addClass(that.config.triggerActiveClass[index]);
	});
	this.$carouselItem.eq(that.config.startActive)
		.addClass(this.config.itemActiveClass);

	$('.' + this.config.itemWrapperClass).addClass(that.config.itemWrapperClass + '--active');

	this.$activeSlide = this.$carouselItem.eq(that.config.startActive);
}

// Initializes default activation function
Carousel.prototype.activate = function () {
	if (this.$carousel.length == 0) return;

	this.initStartActive();
	this.initHandlers();
	this.startCarousel();
	this.initFirstLast();
	this.startImageLoop();
}

module.exports = Carousel;